import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { collect, tryFind } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { defaultOf, uncurry2, int32ToString, equals } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { generateQueryString } from "../Shared/Urls.js";
import { some, unwrap, map, defaultArg, value as value_14 } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { Company_$reflection } from "../Shared/ApiDataTypes.js";
import { obj_type, array_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { testRedirect, extraCoders } from "../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TextField, Autocomplete } from "@mui/material";
import { delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";

/**
 * Downloads the provided company and loads all departments in an autocomplete
 */
export function DepartmentSelect(departmentSelectInputProps) {
    const selectedDepartmentId = departmentSelectInputProps.selectedDepartmentId;
    const onUpdate = departmentSelectInputProps.onUpdate;
    const companyIdOpt = departmentSelectInputProps.companyIdOpt;
    const patternInput = reactApi.useState([]);
    const departments = patternInput[0];
    const departmentOpt = tryFind((department) => equals(department.Id, selectedDepartmentId), departments);
    const dependencies = [companyIdOpt];
    reactApi.useEffect(() => {
        let properties_2;
        if (companyIdOpt != null) {
            const url = "/api/company" + generateQueryString([["id", int32ToString(value_14(companyIdOpt))]]);
            let pr_2;
            let pr_1;
            const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Company_$reflection()), undefined, undefined);
            const data_1 = undefined;
            const caseStrategy_2 = undefined;
            const extra_2 = extraCoders;
            try {
                const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Company_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
            }
            catch (exn) {
                pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
            pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
            pr_2.then((res) => {
                if (res.tag === 0) {
                    patternInput[1](collect((_arg_2) => _arg_2.Departments, res.fields[0]));
                }
                else {
                    console.error(some("Error fetching companies"), res.fields[0]);
                }
            });
        }
    }, dependencies);
    return MuiHelpers_createElement(Autocomplete, [["size", "small"], ["multiple", false], ["disabled", companyIdOpt == null], ["getOptionLabel", (company) => company.Name], ["value", defaultArg(departmentOpt, defaultOf())], ["options", Array.from(departments)], ["onChange", (delegateArg, delegateArg_1, delegateArg_2) => {
        const opt = delegateArg_1;
        console.debug("[DepartmentSelect] Selected option: %o", opt);
        onUpdate(opt);
    }], ["renderInput", (p) => MuiHelpers_createElement(TextField, toList(delay(() => (Object.entries(p)))))]]);
}

